import { useContext } from "react";
import LoginForm from "../components/LoginForm";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../services/UserContext";
import { API } from "../services/config";

export default function LoginPage() {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleLogin = async ({ phone, password }) => {
    
    const response = await fetch(`${API}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ phone, password }),
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.error || "Error al iniciar sesión");
    }

    const data = await response.json();
    const authUser = {
      ...data.user,
      profesional: data.profesional || null,
    };

    // 🔑 Guardamos token en localStorage
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(authUser));

    // 🔐 Guardamos también en contexto global
    setUser(authUser);

    // Redirigimos al inicio
    navigate("/", { replace: true });
  };

  return <LoginForm onLogin={handleLogin} />;
}
